import { render, staticRenderFns } from "./createProductGroup.vue?vue&type=template&id=a8c40308"
import script from "./createProductGroup.vue?vue&type=script&lang=js"
export * from "./createProductGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports